import { defineStore } from 'pinia'

import { api, ensureCsrf } from '@/shared/api/http'
import type { AuthResponse, CurrentUser } from './types'

export const useAuthStore = defineStore('auth', {
  state: () => ({ user: null as CurrentUser | null, loaded: false }),
  getters: {
    isAuthenticated: (state) => Boolean(state.user),
    can: (state) => (permission: string) => state.user?.permissions.includes(permission) ?? false,
  },
  actions: {
    async restore() {
      if (this.loaded) return
      try {
        this.user = (await api<AuthResponse>('/api/v1/auth/me')).user
      } catch {
        this.user = null
      } finally {
        this.loaded = true
      }
    },
    async login(username: string, password: string, remember: boolean) {
      await ensureCsrf()
      this.user = (
        await api<AuthResponse>('/api/v1/auth/login', {
          method: 'POST',
          body: JSON.stringify({ username, password, remember }),
        })
      ).user
      this.loaded = true
    },
    async logout() {
      await ensureCsrf()
      await api<void>('/api/v1/auth/logout', { method: 'POST' })
      this.user = null
    },
    async changePassword(oldPassword: string, newPassword: string) {
      await ensureCsrf()
      await api<void>('/api/v1/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
      })
      this.user = null
      this.loaded = false
    },
  },
})
